import { render, staticRenderFns } from "./TypeOfRightTree.vue?vue&type=template&id=38c339ac&scoped=true&"
import script from "./TypeOfRightTree.vue?vue&type=script&lang=js&"
export * from "./TypeOfRightTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c339ac",
  null
  
)

export default component.exports